import { render, staticRenderFns } from "./order-edit-info.vue?vue&type=template&id=815ba29e&"
import script from "./order-edit-info.vue?vue&type=script&lang=js&"
export * from "./order-edit-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports